<template>
  <div class="maxwidht">
    <div class="login-container">
      <div class="login-box">
        <h2>注册账号</h2>
        <p>输入手机号和密码注册</p>
        <div class="login-area">
          <div>
            <input type="text" placeholder="请输入手机号" v-model="account" />
            <input type="password" placeholder="请输入密码" v-model="password" />
            <input type="password" placeholder="再次输入密码确认" v-model="password_confirm" />
          </div>
          <button @click="registerAccount">注册</button>
        </div>

        <!-- <p class="icp">冀ICP备20011305号-3</p> -->
      </div>
    </div>
    <div class="flex agreement">
        <div>
          <div class="flex">
            <div class="smallsize" @click="agreement">《用户协议》</div>
            <div class="smallsize" @click="privacy">《隐私协议》</div>
          </div>
          <div>
            <p class="icp" v-html="ICPhtml"></p>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import {
  register
} from "../utils/api"
export default {
  data() {
    return {
      account: '',
      password: '',
      password_confirm: '',
      agreed: false,
      ICPhtml:'Copyright © 2021-2024 聚创(邯郸)文化传媒有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备20011305号-3</a>',
    };
  },
  created() {
    var domain = window.location.hostname;
    if(domain=='wl.bjczjy.cn'){
      this.ICPhtml = 'Copyright © 2021-2024 邯郸传正文化发展有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备19032043号-3</a>'
    }
  },
  methods: {
    //账号注册
    registerAccount() {
      let reg = /^1[3-9]\d{9}$/;
      if (!this.account) {
        this.$message({
          type: 'error',
          message: '手机号不能为空'
        });
        return
      }
      if (!reg.test(this.account)) {
        this.$message({
          type: 'error',
          message: '请输入正确手机号'
        });
        return
      }
      if (!this.password) {
        this.$message({
          type: 'error',
          message: '请输入密码'
        });
        return
      }
      if (!this.password_confirm) {
        this.$message({
          type: 'error',
          message: '请确认密码'
        });
        return
      }
      if (this.password_confirm != this.password) {
        this.$message({
          type: 'error',
          message: '两次密码不一致'
        });
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        channel: '3',
        account: this.account,
        password: this.password,
        password_confirm: this.password_confirm,
      }
      register(params).then(res => {
        this.$message({
          type: 'success',
          message: '注册成功'
        });
        setTimeout(() => {
          this.$router.replace({
            path: '/login'
          })
          loading.close();
        }, 1000)
      }).catch(() => {
        loading.close();
      })
    },

    agreement() {
      this.$router.push({
        name: 'agreement'
      })
    },
    privacy() {
      this.$router.push({
        name: 'privacy'
      })
    }
  },
};
</script>

<style scoped>
.maxwidht {
  max-width: 500px;
  height: 100vh;
  margin: 0 auto;
  background-image: url('../assets/loginbg.png');
  display: flex;
  flex-direction: column;
}

.login-container {
  padding: 20px;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.agreement {
  flex: 1;
  align-items: flex-end;
  padding: 20px;
}

.flex {
  display: flex;
  justify-content: center;
}


.smallsize {
  font-size: 14px;
  color: #888;
  width: 100%;
  text-align: center;
}

.login-box {}

.login-area {
  padding: 20px 20px;
}

h2 {

  margin-bottom: 10px;
}

p {
  color: #888;
  font-size: 14px;
  margin-bottom: 20px;
}

input {
  width: 93%;
  display: block;
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.agreement-input {
  width: fit-content !important;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #ee5b4d;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 0 20px;
}

label {
  font-size: 12px;
  color: #888;
  margin-left: 5px;
}

a {
  color: #888;
  text-decoration: underline;
  margin-left: 5px;
}

.icp {
  font-size: 12px;
  color: #aaa;
  margin-top: 20px;
  text-align: center;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
}

.header-container img {
  width: 30px;
}

.header-container .register {
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue